import type { MediaView } from "@joogoos/contracts";

/** Where a picture in the library came from, grouped the same on the Studio's photo step and on Business (03 §your look). */
export type PhotoGroup = "yours" | "site" | "made";

export const PHOTO_GROUPS: ReadonlyArray<readonly [PhotoGroup, string, string]> = [
  ["yours", "Your photos", "what you have uploaded"],
  ["site", "From your lookup", "the pictures you kept from your website, your Google listing and your pages online"],
  ["made", "From your posts", "pictures made for you before"],
];

/** A logo is in no group: it is not a photo to make a post with, and it lives on Your look. */
export function photoGroup(m: MediaView): PhotoGroup | null {
  if (m.tags.includes("logo")) return null;
  if (m.origin === "uploaded") return "yours";
  if (m.origin === "website" || m.origin === "google" || m.origin === "web") return "site";
  if (m.origin === "generated") return "made";
  return null;
}
